import { API_BASE_URL } from '@/lib/api'

/**
 * Where the gateway serves its own API documentation.
 *
 * The old admin sidebar linked `/docs` relative to the app. In every build
 * that is the SPA's own origin, so the router answered with the shell and the
 * page rendered blank — the documentation is served by the **gateway**, not by
 * this app.
 *
 * `API_BASE_URL` is the gateway's origin in a build that has one
 * (`VITE_API_BASE_URL`), and empty where app and gateway share an origin. The
 * empty case splits in two:
 *
 * - in production an empty base really does mean same origin, so `/docs` is
 *   right;
 * - in `vite dev` it means the dev server proxies `/v1`, `/public` and
 *   `/health` to the local gateway — and nothing else. `/docs` would hit the
 *   SPA again, so the link points straight at the proxy's target.
 */
export const DEV_GATEWAY_ORIGIN = 'http://localhost:8085'

export function apiDocsUrl(base: string = API_BASE_URL, dev: boolean = import.meta.env.DEV): string {
  const trimmed = base.replace(/\/+$/, '')
  if (trimmed) return `${trimmed}/docs`
  return dev ? `${DEV_GATEWAY_ORIGIN}/docs` : '/docs'
}
